function playToneSequence(tones) {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;

    const context = new AudioContext();

    tones.forEach(({ frequency, start, duration, volume = 0.1, type = 'sine' }) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();

      oscillator.type = type;
      oscillator.frequency.setValueAtTime(frequency, context.currentTime + start);
      gain.gain.setValueAtTime(0.0001, context.currentTime + start);
      gain.gain.exponentialRampToValueAtTime(volume, context.currentTime + start + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + start + duration);

      oscillator.connect(gain);
      gain.connect(context.destination);
      oscillator.start(context.currentTime + start);
      oscillator.stop(context.currentTime + start + duration + 0.02);
    });

    const lastToneEnd = Math.max(...tones.map((tone) => tone.start + tone.duration), 0);
    window.setTimeout(() => context.close().catch(() => {}), (lastToneEnd + 0.35) * 1000);
  } catch (_error) {
    // Les navigateurs peuvent bloquer le son sans interaction utilisateur.
  }
}

export function playNotificationSound() {
  playToneSequence([
    { frequency: 880, start: 0, duration: 0.12, volume: 0.12 },
    { frequency: 1175, start: 0.15, duration: 0.16, volume: 0.12 },
  ]);
}

export function playActionSound(severity = 'success') {
  if (severity === 'error') {
    playToneSequence([
      { frequency: 220, start: 0, duration: 0.11, volume: 0.09, type: 'triangle' },
      { frequency: 165, start: 0.12, duration: 0.14, volume: 0.08, type: 'triangle' },
    ]);
    return;
  }

  if (severity === 'warning') {
    playToneSequence([
      { frequency: 440, start: 0, duration: 0.09, volume: 0.08 },
      { frequency: 660, start: 0.1, duration: 0.12, volume: 0.09 },
    ]);
    return;
  }

  playToneSequence([
    { frequency: 660, start: 0, duration: 0.08, volume: 0.08 },
    { frequency: 990, start: 0.09, duration: 0.11, volume: 0.1 },
  ]);
}
